import scope from 'recompose-scope/composeWithScope'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import SingleSelectCondition from './SingleSelectCondition'

import View from './Filter'

function buildUrl (url, query) {
  if (!query) return url

  const queries = []
  Object.keys(query).forEach(key => {
    if (query[key] === undefined) return
    queries.push(`${key}=${encodeURIComponent(JSON.stringify(query[key]))}`)
  })

  return `${url}?${queries.join('&')}`
}


const SalesOrderDetail = scope(
  withState('query', 'setQuery', {}),

  withProps({
    fields: ['billDate', 'customerGroupRef', 'customerRef', 'onlyLens'],
    schema: {
      type: 'object',
      contents: {
        billDate: {
          name: '結帳日期',
          type: 'Date',
          format: 'YYYY/MM/DD',
        },
        customerGroupRef: {
          name: '客戶群組',
          type: 'ObjectId',
          reference: 'customerGroups',
          refKeys: ['key'],
        },
        customerRef: {
          name: '客戶門市',
          type: 'ObjectId',
          reference: 'customers',
          refKeys: ['key', 'name'],
        },
        onlyLens: {
          name: '寶島特殊',
          type: 'String',
          options: ['純代工類(無鏡片)', '非純代工類(有鏡片)', '不分類'],
          queryEditor: 'singleSelect',
        },
      },
    },
    setting: {
      editorByKey: {
        onlyLens: SingleSelectCondition,
      },
    },
  }),

  withHandlers({
    download: ({ query }) => () => {
      const url = buildUrl('api/print/salesOrderReport/xlsx', query)
      window.open(url, '_blank')
    },
  }),

  exposeProps([
    'query',
    'setQuery',
    'fields',
    'schema',
    'setting',

    'download',
  ]),
)(View)

SalesOrderDetail.displayName = 'SalesOrderDetail'

export default SalesOrderDetail



// WEBPACK FOOTER //
// ./src/components/SalesOrderReport/index.js